import { showToast } from '../../components/Toast';
import {
  getLostOrdersSuccess,
  getLostOrdersFail,
  addLostOrderSuccess,
  addLostOrderFail,
  updateLostOrderSuccess,
  updateLostOrderFail,
  deleteLostOrderSuccess,
  deleteLostOrderFail,
  showLoading,
  hideLoading,
} from '../../store/lostOrders/actions';
import { WsEvents } from '../events';
import { socket } from '../socket';

/**
 * not being used anywhere kept just for reference purposes
 */
export function getLostOrders({ dispatch }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.lostOrders.GET_DATA, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(showLoading(true));
      dispatch(getLostOrdersFail(res));
      return;
    }
    dispatch(getLostOrdersSuccess(res));
    dispatch(hideLoading(false));
  }
}

export function onAddLostOrder({ dispatch, newOrder }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.lostOrders.ADD, newOrder, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(addLostOrderFail(res));
      return;
    }
    showToast('New Lost Order is added');
    dispatch(addLostOrderSuccess(res));
    dispatch(hideLoading(false));
  }
}

export function onUpdateLostOrder({ dispatch, updateLostOrder }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.lostOrders.UPDATE, updateLostOrder, callback);

  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(updateLostOrderFail(res));
      return;
    }
    showToast('Changes Successfully Applied');
    dispatch(updateLostOrderSuccess(res));
    dispatch(hideLoading(false));
  }
}

export function onDeleteLostOrder({ dispatch, id }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.lostOrders.DELETE, id, callback);

  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(deleteLostOrderFail(res));
      return;
    }
    showToast('Order is deleted from the system');
    dispatch(deleteLostOrderSuccess(res));
    dispatch(hideLoading(false));
  }
}
